// extracted by mini-css-extract-plugin
export default {"lds_ripple":"Pulse_lds_ripple__5ax75"};